// ============================================
// useShippingQuote — Estado del envío por peso del carrito (distribuidoras)
// none → requested → quoted; "stale" si el carrito cambió desde la solicitud.
// ============================================

import { useCallback, useEffect, useState } from 'react';
import { getShippingQuote, requestShippingQuote } from '../services/medusa/shippingQuote';

export function useShippingQuote(cart, enabled) {
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(false);
  const cartId = cart?.id;
  // Volver a consultar cuando cambia el contenido del carrito.
  const itemsKey = (cart?.items || []).map((i) => `${i.variant_id}:${i.quantity}`).join('|');

  const refresh = useCallback(async () => {
    if (!enabled || !cartId) return;
    setLoading(true);
    try {
      setQuote(await getShippingQuote(cartId));
    } catch {
      setQuote(null);
    } finally {
      setLoading(false);
    }
  }, [enabled, cartId]);

  useEffect(() => {
    refresh();
  }, [refresh, itemsKey]);

  const request = useCallback(
    async (postalCode, note) => {
      const q = await requestShippingQuote(cartId, postalCode, note);
      setQuote(q);
      return q;
    },
    [cartId]
  );

  return { quote: enabled ? quote : null, loading, request, refresh };
}
